

































































































































































































































































































































































import Element from 'element-ui'
import { Component, Vue, Watch, Prop } from 'vue-property-decorator'
import { UnitFourData, emptyUnitFour, getInfo } from '@/api/heritageUnit/unitFour'
import UnitFileGallery from '@/components/heritageUnit/view/fileGallery.vue'
import UnitFourRubbingView from '@/components/heritageUnit/view/four/rubbing.vue'
import UnitFourVolumeView from '@/components/heritageUnit/view/four/volume.vue'

@Component({
  components: {
    UnitFileGallery,
    UnitFourRubbingView,
    UnitFourVolumeView
  }
})
export default class UnitFourView extends Vue {
  public name = 'UnitFourView'
  public loading = false
  public maxHeight: string = '400px'
  public mainExpands: string[] = [
    'Relic', //附属文物
    'Collection', //文物藏品
    'FamousTree', //古树名木
    // 'Drawing', //图纸卷
    // 'Picture', //照片卷
    // 'Rubbing1', //拓片
    // 'Rubbing2', //摹本
    // 'Volume101', //调查发掘
    // 'Volume102', //防治监测
    // 'Volume103', //文物展示
    // 'Volume104', //电子文件
    // 'Volume105', //文字卷
    // 'Volume106', //保护规划及保护工程方案
    'Volume199' //续补卷
  ]
  public deputyExpands: string[] = [
    'Volume201', //行政管理
    // 'Volume202', //法律文书
    // 'Volume203', //大事记
    'Volume299' //续补卷
  ]
  public prepareExpands: string[] = [
    'Volume301', //参考资料
    // 'Volume302', //论文卷
    // 'Volume303', //图书卷
    'Volume399' //续补卷
  ]
  public $refs!: {
    formData: Element.Form
    picCtrl: UnitFileGallery
    drawCtrl: UnitFileGallery
    rubbingCtrl1: UnitFourRubbingView
    rubbingCtrl2: UnitFourRubbingView

    volumeCtrl101: UnitFourVolumeView
    volumeCtrl102: UnitFourVolumeView
    volumeCtrl103: UnitFourVolumeView
    volumeCtrl104: UnitFourVolumeView
    volumeCtrl105: UnitFourVolumeView
    volumeCtrl106: UnitFourVolumeView
    volumeCtrl199: UnitFourVolumeView

    volumeCtrl201: UnitFourVolumeView
    volumeCtrl202: UnitFourVolumeView
    volumeCtrl203: UnitFourVolumeView
    volumeCtrl299: UnitFourVolumeView

    volumeCtrl301: UnitFourVolumeView
    volumeCtrl302: UnitFourVolumeView
    volumeCtrl303: UnitFourVolumeView
    volumeCtrl399: UnitFourVolumeView
  }
  public form: UnitFourData = Object.assign({}, emptyUnitFour)
  //数据加载
  public loadData(unitId: number) {
    if (unitId == 0) {
      this.$message({
        message: '文保单位未匹配，请检查',
        type: 'warning'
      })
      console.log('UnitId为0，请赋值')
    } else {
      this.fetchData(unitId)
    }
  }
  public fetchData(unitId: number) {
    this.loading = true
    getInfo(unitId).then((response: { data: any }) => {
      this.form = response.data
      // this.$nextTick(() => {
      //   this.setCtrlsData()
      // })
      this.loading = false
    }).catch((error: any) => {
      console.log(error)
    })
  }
  public setCtrlsData() {
    let f = this.form
    // this.$refs.picCtrl.setData(f.Pictures)
    // this.$refs.drawCtrl.setData(f.Drawings)
    this.$refs.rubbingCtrl1.setData(f.RubbingList1)
    this.$refs.rubbingCtrl2.setData(f.RubbingList2)

    this.$refs.volumeCtrl101.setData(f.VolumeList101)
    this.$refs.volumeCtrl102.setData(f.VolumeList102)
    this.$refs.volumeCtrl103.setData(f.VolumeList103)
    this.$refs.volumeCtrl104.setData(f.VolumeList104)
    this.$refs.volumeCtrl105.setData(f.VolumeList105)
    this.$refs.volumeCtrl106.setData(f.VolumeList106)
    this.$refs.volumeCtrl199.setData(f.VolumeList199)

    this.$refs.volumeCtrl201.setData(f.VolumeList201)
    this.$refs.volumeCtrl202.setData(f.VolumeList202)
    this.$refs.volumeCtrl203.setData(f.VolumeList203)
    this.$refs.volumeCtrl299.setData(f.VolumeList299)

    this.$refs.volumeCtrl301.setData(f.VolumeList301)
    this.$refs.volumeCtrl302.setData(f.VolumeList302)
    this.$refs.volumeCtrl303.setData(f.VolumeList303)
    this.$refs.volumeCtrl399.setData(f.VolumeList399)
  }
}
